export const UPDATE_RECIEVE_ML_ACCOUNT = 'UPDATE_RECIEVE_ML_ACCOUNT';
export const UPDATE_RECIEVE_ML_CARD = 'UPDATE_RECIEVE_ML_CARD';
export const SET_EXTRA = 'SET_EXTRA';
export const UPDATE_EXTRA_BY_NAME = 'UPDATE_EXTRA_BY_NAME';
export const ADD_EXTRA = 'ADD_EXTRA';
export const ADD_EXTRAS = 'ADD_EXTRAS';
export const UPDATE_ML_STATUS = 'UPDATE_ML_STATUS';
export const RENAME_GA_PAYMENT = 'RENAME_GA_PAYMENT';
export const RENAME_AWAITING_PAYMENT = 'RENAME_AWAITING_PAYMENT';
export const DELETE_DC_SOURCES_ACCOUNT = 'DELETE_DC_SOURCES_ACCOUNT';
export const setExtra = (extra) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_EXTRA,
                extra: extra,
            }),
        );
    };
};
export const updateExtraByName = (extraName, value) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_EXTRA_BY_NAME,
                extraName: extraName,
                value: value,
            }),
        );
    };
};

export const addExtra = (extraName, extra) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_EXTRA,
                extraName: extraName,
                extra: extra,
            }),
        );
    };
};

export const addExtras = (extra) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_EXTRAS,
                extra: extra,
            }),
        );
    };
};

export const updateCard = (alias, code, paymentSystem, cardLogo, cvvFocus = false) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_RECIEVE_ML_CARD,
                alias: alias,
                code: code,
                paymentSystem: paymentSystem,
                cardLogo: cardLogo,
                cvvFocus: cvvFocus,
            }),
        );
    };
};

export const updateAccount = (code, alias, bankLogo) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_RECIEVE_ML_ACCOUNT,
                code: code,
                alias: alias,
                bankLogo: bankLogo,
            }),
        );
    };
};
export const deleteDCAccount = (accountId, typeAccount) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: DELETE_DC_SOURCES_ACCOUNT,
                accountId,
                typeAccount,
            }),
        );
    };
};

export const renameGlobalAccountPayment = (payId, name = '') => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: RENAME_GA_PAYMENT,
                payId: payId,
                name: name,
            }),
        );
    };
};

export const renameAwaitingPayment = (paymentId, name = '') => ({
    type: RENAME_AWAITING_PAYMENT,
    paymentId,
    name,
});
